import React from 'react';

export interface PlatformFooterProps {
  tenantName?: string;
  showTenantBranding?: boolean;
}

const PlatformFooter: React.FC<PlatformFooterProps> = ({ 
  tenantName, 
  showTenantBranding = false 
}) => {
  return (
    <div className="text-center mt-8 pb-6 opacity-80 transition-opacity hover:opacity-100">
      <p className="text-xs font-medium text-slate-500">
        © 2025 {showTenantBranding && tenantName ? tenantName : "OBIS Edutech Inc."} — All rights reserved.
      </p>
      <p className="text-[10px] uppercase tracking-wider font-bold mt-1 text-slate-400">
        Powered by OBIS EduNexus
      </p>
    </div>
  );
};

export default PlatformFooter;
